import { render, staticRenderFns } from "./vue-pagination.vue?vue&type=template&id=0b448d22&scoped=true&"
import script from "./vue-pagination.vue?vue&type=script&lang=js&"
export * from "./vue-pagination.vue?vue&type=script&lang=js&"
import style0 from "./vue-pagination.vue?vue&type=style&index=0&id=0b448d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b448d22",
  null
  
)

export default component.exports